import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-splash',
  templateUrl: './splash.component.html',
  styleUrl: './splash.component.scss',
})
export class SplashComponent {
  closed = false;
  constructor(private modalCtrl: ModalController) {
    setTimeout(() => {
      if (!this.closed) this.close();
    }, 3000);
  }

  close() {
    this.closed = true;
    this.modalCtrl.dismiss();
  }
}
